// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__DJ3Bu","spinner":"Loading_spinner__AUQ28","text":"Loading_text__1nNZl","spinnerContainer":"Loading_spinnerContainer__VKNF0"};